import { useState, useEffect } from "react";
import { RiFileExcel2Fill } from "react-icons/ri";
import { MdDownload } from "react-icons/md";
import axiosInstance from "./Axios";
import { useSelector, useDispatch } from "react-redux";
import { DateDetailsData } from "../Redux/Reducers/Common/AssessmentDate";
import { ADNOptionsData } from "../Redux/Reducers/Common/AssDatesByName";
import { current } from "@reduxjs/toolkit";
import { uselocation } from "react-router-dom"
export function ExportXlButton(props) {
    return (
        <div onClick={props.Click} className="Buttons CPointer dflex alignitems JCCenter gap-1" title="Export to Excel">
            <RiFileExcel2Fill /> {props.Name}
        </div>
    )
}

export function DownloadGraphButton(props) {
    return (
        <div onClick={props.Click} className="Buttons CPointer" style={{ padding: "5px 7px" }}>
            <MdDownload /> {props.Name}
        </div>
    )
}

// Below is for Assessment names(Goviand sir)
export function AssessmentNameDates(props) {
    const dispatch = useDispatch();
    const USYear = useSelector((state) => state.SelecYearData.SYear);
    const items = useSelector((state) => state.userDetailsData.LoginDetails);
    const [Options, SetOptions] = useState([]);
    const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
    const [Stab, SetSTab] = useState(1);
    const [DatesOptions, SetDatesOptions] = useState();
    const [FIletrData, SetFIletrData] = useState();
    const [Duplicate, SetDuplicate] = useState();
    const GetDates = async () => {

        if (USYear?.display === "2024-25" || USYear?.display === "2025-26") {
            SetOptions([
                { Name: "SODHANA", Value: 1 },
                { Name: "SADHANA", Value: 2 },
                { Name: "SAMAGRA", Value: 3 }
            ]);
        } else {
            SetOptions([
                { Name: "SODHANA", Value: 1 },
                { Name: "SAMAGRA", Value: 3 }
            ]);
        }
        try {
            const res = await axiosInstance.get(
                `/Principal/GetAssessmentTypesAndDatesByInstitute?Year=${USYear?.value}&InstituteId=${items?.instituteId}&UserId=${items?.userId}&SocietyId=${items?.societyId || 0}`
            );
            if (res.data[0]?.assessmentType) {
                const count = Count(Stab, res.data) > 0 ? Stab : Count(Stab || 1, res.data) > 0 ? 1 : 2;
                const Options = res.data.filter((item) => item?.assessmentType === (SelectDate?.assessmentType || count)).map((Assessment) => ({
                    display: Assessment.assessmentTypeName,
                    value: Assessment.contestCreationId,
                    ...Assessment,
                }));
                SetSTab(Count(SelectDate?.assessmentType, res.data) > 0 ? SelectDate?.assessmentType : count);
                const SortData = [...Options].sort((a, b) => a.display.localeCompare(b.display));
                console.log("SortData",SortData);
                localStorage.setItem("SDates",JSON.stringify(SortData));
                const FindSelect = SortData?.find((item) => item.value === SelectDate?.value);
                dispatch(DateDetailsData({ DateDetails: FindSelect?.value ? FindSelect : SortData[0] }))
                SetFIletrData(SortData);
                SetDatesOptions(res.data);
                const FindDuplicate = SortData.reduce((acc, current) => {
                    if (!acc[current.display]) {
                        acc[current.display] = [];
                    }
                    acc[current.display].push(current)
                    return acc;
                }, {})
                SetDuplicate(FindDuplicate);
            } else {
                dispatch(DateDetailsData({ DateDetails: "" }))
                SetFIletrData();
                SetDatesOptions();
                SetSTab();
                SetDuplicate();
            }
        } catch (err) {
            console.log(err);
        }
    }
    useEffect(() => { if (USYear?.value) { GetDates() } }, [USYear])
    useEffect(() => {
        if ((props.Path === "/Principle/SamagraDashboard" || props.Path === "/SamagraDashboard") && DatesOptions?.length > 0) {
            Storedata(3);
        }else if( DatesOptions?.length > 0){
            // props.Path === "/Principle/PrincipleReportCard" &&
            Storedata(1);
        }
    }, [props.Path, DatesOptions])
    const Storedata = (e) => {
        SetSTab(e)
        const formated = DatesOptions?.filter((item) => item?.assessmentType === e).map((Assessment) => ({
            display: Assessment.assessmentTypeName,
            value: Assessment.contestCreationId,
            ...Assessment,
        }))
        const SortData = [...formated].sort((a, b) => a.display?.localeCompare(b.display));
        const FindSelect = SortData?.find((item) => item.value === SelectDate?.value);
        dispatch(DateDetailsData({ DateDetails: FindSelect?.value ? FindSelect : SortData[0] }))
        SetFIletrData(SortData);
        const FindDuplicate = SortData.reduce((acc, current) => {
            if (!acc[current.display]) {
                acc[current.display] = [];
            }
            acc[current.display].push(current)
            return acc;
        }, {})
        SetDuplicate(FindDuplicate);
    }
    const FindAss = (e) => {
        const Data = DatesOptions?.find((item) => item.assessmentTypeName.split(" ")?.[0].toLowerCase() === e.toLowerCase());
        return Data ? true : false
    }
    const Count = (e, Data) => {
        const Count = (Data || DatesOptions)?.filter((Num) => Num.assessmentType === e)[0]
        switch (e) {
            case 1: return Count?.sodhanaCount
            case 2: return Count?.sadhanaCount
            case 3: return Count?.samagraCount
        }
    }
    return (
        <div className="dflex flexd-column gap-0">
            <div className="dflex gap-3 JCCenter">
                {DatesOptions && Options?.map((item) => (
                    // && props.Path !== "/SamagraDashboard"

                    (!props.Path.includes("/SamagraDashboard") ? item.Value !== 3 :props.Path.includes("/SamagraDashboard") ? false : true) &&
                    <button className={`${item.Value === Stab ? "ANDSelect" : (((props.Path.includes("/InstitutionAdmin/Performance") && item.Value === 3) ? (FindAss(item.Name) && item.Value !== 3) : FindAss(item.Name)) ? "ANDNotSelect" : "ANDisable")} Buttons`}
                        onClick={() => Storedata(item.Value)} disabled={!FindAss(item.Name) || props.Path.includes("/InstitutionAdmin/Performance") && item.Value === 3}
                        // || ((items?.userTypeId === 10 || items?.userTypeId === 8) && item.Value === 3 )
                        // && location?.path !== "/Institution/Assessments%20Participation" && props.Path !== "/SamagraDashboard"
                        title={`${!FindAss(item.Name) ? "Not Participated" : ""}`}
                    >{item.Name}{props.Path.includes("/InstitutionAdmin/Performance") && item.Value === 3 ? "" : `(${Count(item.Value) || 0})`} </button>
                ))}
                {/* props.Path === "/SamagraDashboard" ||  props.Path === "/InstitutionAdmin/Performance" */}
            </div>
            {/* <div className="DateOptions">
                {FIletrData?.map((date, index) => (
                    <>
                        <div onClick={() => dispatch(DateDetailsData({ DateDetails: date }))}
                            className={`${date?.value === SelectDate?.value ? "ANDOptionSelect" : "ANDOptionNotSelect"}`}>
                            <span style={{ textDecoration: "none" }}>{date?.display?.split(" ")[1]}  </span> <span>{date?.examStartDate}</span> </div> {(FIletrData?.length - 2) >= index && "|"} </>
                ))}
            </div> */}

            <div className="DateOptions gap-0 ">
                {Object.values(Duplicate || {}).map((dates, index) => (
                    <>
                        <div className={`${dates[0]?.display === SelectDate?.display ? "ANDOptionSelect p-0" : "ANDOptionNotSelect p-0"}`}>
                            <span className="mx-2">{dates[0]?.display?.split(" ")[1]} </span>
                        </div>

                        {dates.map((date, index) => (
                            <>
                                <div onClick={() => dispatch(DateDetailsData({ DateDetails: date }))}
                                    className={`${date?.value === SelectDate?.value ? "ANDOptionSelect" : "ANDOptionNotSelect"}`}>
                                    <span style={{ display: "none" }}></span> <span>{date?.examStartDate}</span> </div>  </>
                        ))}{(Object.values(Duplicate || {})?.length - 2) >= index && "| "}
                    </>
                ))}
            </div>
            {/* <span style={{ textDecoration: "none" }}>{date?.display?.split(" ")[1]}</span> */}
        </div>
    )
}
// Above is for Assessment names(Goviand sir)